// Code generated by typegen/main.go. DO NOT EDIT.

// Countries represents all supported countries with their flags
export const countries = [
	{
		name: "Afghanistan",
		flag: "🇦🇫",
	},
	{
		name: "Åland Islands",
		flag: "🇦🇽",
	},
	{
		name: "Albania",
		flag: "🇦🇱",
	},
	{
		name: "Algeria",
		flag: "🇩🇿",
	},
	{
		name: "American Samoa",
		flag: "🇦🇸",
	},
	{
		name: "Andorra",
		flag: "🇦🇩",
	},
	{
		name: "Angola",
		flag: "🇦🇴",
	},
	{
		name: "Anguilla",
		flag: "🇦🇮",
	},
	{
		name: "Antarctica",
		flag: "🇦🇶",
	},
	{
		name: "Antigua and Barbuda",
		flag: "🇦🇬",
	},
	{
		name: "Argentina",
		flag: "🇦🇷",
	},
	{
		name: "Armenia",
		flag: "🇦🇲",
	},
	{
		name: "Aruba",
		flag: "🇦🇼",
	},
	{
		name: "Australia",
		flag: "🇦🇺",
	},
	{
		name: "Austria",
		flag: "🇦🇹",
	},
	{
		name: "Azerbaijan",
		flag: "🇦🇿",
	},
	{
		name: "Bahamas",
		flag: "🇧🇸",
	},
	{
		name: "Bahrain",
		flag: "🇧🇭",
	},
	{
		name: "Bangladesh",
		flag: "🇧🇩",
	},
	{
		name: "Barbados",
		flag: "🇧🇧",
	},
	{
		name: "Belarus",
		flag: "🇧🇾",
	},
	{
		name: "Belgium",
		flag: "🇧🇪",
	},
	{
		name: "Belize",
		flag: "🇧🇿",
	},
	{
		name: "Benin",
		flag: "🇧🇯",
	},
	{
		name: "Bermuda",
		flag: "🇧🇲",
	},
	{
		name: "Bhutan",
		flag: "🇧🇹",
	},
	{
		name: "Bolivia, Plurinational State of",
		flag: "🇧🇴",
	},
	{
		name: "Bonaire, Sint Eustatius and Saba",
		flag: "🇧🇶",
	},
	{
		name: "Bosnia and Herzegovina",
		flag: "🇧🇦",
	},
	{
		name: "Botswana",
		flag: "🇧🇼",
	},
	{
		name: "Bouvet Island",
		flag: "🇧🇻",
	},
	{
		name: "Brazil",
		flag: "🇧🇷",
	},
	{
		name: "British Indian Ocean Territory",
		flag: "🇮🇴",
	},
	{
		name: "Brunei Darussalam",
		flag: "🇧🇳",
	},
	{
		name: "Bulgaria",
		flag: "🇧🇬",
	},
	{
		name: "Burkina Faso",
		flag: "🇧🇫",
	},
	{
		name: "Burundi",
		flag: "🇧🇮",
	},
	{
		name: "Cambodia",
		flag: "🇰🇭",
	},
	{
		name: "Cameroon",
		flag: "🇨🇲",
	},
	{
		name: "Canada",
		flag: "🇨🇦",
	},
	{
		name: "Cape Verde",
		flag: "🇨🇻",
	},
	{
		name: "Cayman Islands",
		flag: "🇰🇾",
	},
	{
		name: "Central African Republic",
		flag: "🇨🇫",
	},
	{
		name: "Chad",
		flag: "🇹🇩",
	},
	{
		name: "Chile",
		flag: "🇨🇱",
	},
	{
		name: "China",
		flag: "🇨🇳",
	},
	{
		name: "Christmas Island",
		flag: "🇨🇽",
	},
	{
		name: "Cocos (Keeling) Islands",
		flag: "🇨🇨",
	},
	{
		name: "Colombia",
		flag: "🇨🇴",
	},
	{
		name: "Comoros",
		flag: "🇰🇲",
	},
	{
		name: "Congo",
		flag: "🇨🇬",
	},
	{
		name: "Congo, the Democratic Republic of the",
		flag: "🇨🇩",
	},
	{
		name: "Cook Islands",
		flag: "🇨🇰",
	},
	{
		name: "Costa Rica",
		flag: "🇨🇷",
	},
	{
		name: "Côte d'Ivoire",
		flag: "🇨🇮",
	},
	{
		name: "Croatia",
		flag: "🇭🇷",
	},
	{
		name: "Cuba",
		flag: "🇨🇺",
	},
	{
		name: "Curaçao",
		flag: "🇨🇼",
	},
	{
		name: "Cyprus",
		flag: "🇨🇾",
	},
	{
		name: "Czech Republic",
		flag: "🇨🇿",
	},
	{
		name: "Denmark",
		flag: "🇩🇰",
	},
	{
		name: "Djibouti",
		flag: "🇩🇯",
	},
	{
		name: "Dominica",
		flag: "🇩🇲",
	},
	{
		name: "Dominican Republic",
		flag: "🇩🇴",
	},
	{
		name: "Ecuador",
		flag: "🇪🇨",
	},
	{
		name: "Egypt",
		flag: "🇪🇬",
	},
	{
		name: "El Salvador",
		flag: "🇸🇻",
	},
	{
		name: "Equatorial Guinea",
		flag: "🇬🇶",
	},
	{
		name: "Eritrea",
		flag: "🇪🇷",
	},
	{
		name: "Estonia",
		flag: "🇪🇪",
	},
	{
		name: "Ethiopia",
		flag: "🇪🇹",
	},
	{
		name: "Falkland Islands (Malvinas)",
		flag: "🇫🇰",
	},
	{
		name: "Faroe Islands",
		flag: "🇫🇴",
	},
	{
		name: "Fiji",
		flag: "🇫🇯",
	},
	{
		name: "Finland",
		flag: "🇫🇮",
	},
	{
		name: "France",
		flag: "🇫🇷",
	},
	{
		name: "French Guiana",
		flag: "🇬🇫",
	},
	{
		name: "French Polynesia",
		flag: "🇵🇫",
	},
	{
		name: "French Southern Territories",
		flag: "🇹🇫",
	},
	{
		name: "Gabon",
		flag: "🇬🇦",
	},
	{
		name: "Gambia",
		flag: "🇬🇲",
	},
	{
		name: "Georgia",
		flag: "🇬🇪",
	},
	{
		name: "Germany",
		flag: "🇩🇪",
	},
	{
		name: "Ghana",
		flag: "🇬🇭",
	},
	{
		name: "Gibraltar",
		flag: "🇬🇮",
	},
	{
		name: "Greece",
		flag: "🇬🇷",
	},
	{
		name: "Greenland",
		flag: "🇬🇱",
	},
	{
		name: "Grenada",
		flag: "🇬🇩",
	},
	{
		name: "Guadeloupe",
		flag: "🇬🇵",
	},
	{
		name: "Guam",
		flag: "🇬🇺",
	},
	{
		name: "Guatemala",
		flag: "🇬🇹",
	},
	{
		name: "Guernsey",
		flag: "🇬🇬",
	},
	{
		name: "Guinea",
		flag: "🇬🇳",
	},
	{
		name: "Guinea-Bissau",
		flag: "🇬🇼",
	},
	{
		name: "Guyana",
		flag: "🇬🇾",
	},
	{
		name: "Haiti",
		flag: "🇭🇹",
	},
	{
		name: "Heard Island and McDonald Islands",
		flag: "🇭🇲",
	},
	{
		name: "Holy See (Vatican City State)",
		flag: "🇻🇦",
	},
	{
		name: "Honduras",
		flag: "🇭🇳",
	},
	{
		name: "Hong Kong",
		flag: "🇭🇰",
	},
	{
		name: "Hungary",
		flag: "🇭🇺",
	},
	{
		name: "Iceland",
		flag: "🇮🇸",
	},
	{
		name: "India",
		flag: "🇮🇳",
	},
	{
		name: "Indonesia",
		flag: "🇮🇩",
	},
	{
		name: "Iran, Islamic Republic of",
		flag: "🇮🇷",
	},
	{
		name: "Iraq",
		flag: "🇮🇶",
	},
	{
		name: "Ireland",
		flag: "🇮🇪",
	},
	{
		name: "Isle of Man",
		flag: "🇮🇲",
	},
	{
		name: "Israel",
		flag: "🇮🇱",
	},
	{
		name: "Italy",
		flag: "🇮🇹",
	},
	{
		name: "Jamaica",
		flag: "🇯🇲",
	},
	{
		name: "Japan",
		flag: "🇯🇵",
	},
	{
		name: "Jersey",
		flag: "🇯🇪",
	},
	{
		name: "Jordan",
		flag: "🇯🇴",
	},
	{
		name: "Kazakhstan",
		flag: "🇰🇿",
	},
	{
		name: "Kenya",
		flag: "🇰🇪",
	},
	{
		name: "Kiribati",
		flag: "🇰🇮",
	},
	{
		name: "Korea, Democratic People's Republic of",
		flag: "🇰🇵",
	},
	{
		name: "Korea, Republic of",
		flag: "🇰🇷",
	},
	{
		name: "Kuwait",
		flag: "🇰🇼",
	},
	{
		name: "Kyrgyzstan",
		flag: "🇰🇬",
	},
	{
		name: "Lao People's Democratic Republic",
		flag: "🇱🇦",
	},
	{
		name: "Latvia",
		flag: "🇱🇻",
	},
	{
		name: "Lebanon",
		flag: "🇱🇧",
	},
	{
		name: "Lesotho",
		flag: "🇱🇸",
	},
	{
		name: "Liberia",
		flag: "🇱🇷",
	},
	{
		name: "Libya",
		flag: "🇱🇾",
	},
	{
		name: "Liechtenstein",
		flag: "🇱🇮",
	},
	{
		name: "Lithuania",
		flag: "🇱🇹",
	},
	{
		name: "Luxembourg",
		flag: "🇱🇺",
	},
	{
		name: "Macao",
		flag: "🇲🇴",
	},
	{
		name: "Macedonia, the Former Yugoslav Republic of",
		flag: "🇲🇰",
	},
	{
		name: "Madagascar",
		flag: "🇲🇬",
	},
	{
		name: "Malawi",
		flag: "🇲🇼",
	},
	{
		name: "Malaysia",
		flag: "🇲🇾",
	},
	{
		name: "Maldives",
		flag: "🇲🇻",
	},
	{
		name: "Mali",
		flag: "🇲🇱",
	},
	{
		name: "Malta",
		flag: "🇲🇹",
	},
	{
		name: "Marshall Islands",
		flag: "🇲🇭",
	},
	{
		name: "Martinique",
		flag: "🇲🇶",
	},
	{
		name: "Mauritania",
		flag: "🇲🇷",
	},
	{
		name: "Mauritius",
		flag: "🇲🇺",
	},
	{
		name: "Mayotte",
		flag: "🇾🇹",
	},
	{
		name: "Mexico",
		flag: "🇲🇽",
	},
	{
		name: "Micronesia, Federated States of",
		flag: "🇫🇲",
	},
	{
		name: "Moldova, Republic of",
		flag: "🇲🇩",
	},
	{
		name: "Monaco",
		flag: "🇲🇨",
	},
	{
		name: "Mongolia",
		flag: "🇲🇳",
	},
	{
		name: "Montenegro",
		flag: "🇲🇪",
	},
	{
		name: "Montserrat",
		flag: "🇲🇸",
	},
	{
		name: "Morocco",
		flag: "🇲🇦",
	},
	{
		name: "Mozambique",
		flag: "🇲🇿",
	},
	{
		name: "Myanmar",
		flag: "🇲🇲",
	},
	{
		name: "Namibia",
		flag: "🇳🇦",
	},
	{
		name: "Nauru",
		flag: "🇳🇷",
	},
	{
		name: "Nepal",
		flag: "🇳🇵",
	},
	{
		name: "Netherlands",
		flag: "🇳🇱",
	},
	{
		name: "New Caledonia",
		flag: "🇳🇨",
	},
	{
		name: "New Zealand",
		flag: "🇳🇿",
	},
	{
		name: "Nicaragua",
		flag: "🇳🇮",
	},
	{
		name: "Niger",
		flag: "🇳🇪",
	},
	{
		name: "Nigeria",
		flag: "🇳🇬",
	},
	{
		name: "Niue",
		flag: "🇳🇺",
	},
	{
		name: "Norfolk Island",
		flag: "🇳🇫",
	},
	{
		name: "Northern Mariana Islands",
		flag: "🇲🇵",
	},
	{
		name: "Norway",
		flag: "🇳🇴",
	},
	{
		name: "Oman",
		flag: "🇴🇲",
	},
	{
		name: "Pakistan",
		flag: "🇵🇰",
	},
	{
		name: "Palau",
		flag: "🇵🇼",
	},
	{
		name: "Palestine, State of",
		flag: "🇵🇸",
	},
	{
		name: "Panama",
		flag: "🇵🇦",
	},
	{
		name: "Papua New Guinea",
		flag: "🇵🇬",
	},
	{
		name: "Paraguay",
		flag: "🇵🇾",
	},
	{
		name: "Peru",
		flag: "🇵🇪",
	},
	{
		name: "Philippines",
		flag: "🇵🇭",
	},
	{
		name: "Pitcairn",
		flag: "🇵🇳",
	},
	{
		name: "Poland",
		flag: "🇵🇱",
	},
	{
		name: "Portugal",
		flag: "🇵🇹",
	},
	{
		name: "Puerto Rico",
		flag: "🇵🇷",
	},
	{
		name: "Qatar",
		flag: "🇶🇦",
	},
	{
		name: "Réunion",
		flag: "🇷🇪",
	},
	{
		name: "Romania",
		flag: "🇷🇴",
	},
	{
		name: "Russian Federation",
		flag: "🇷🇺",
	},
	{
		name: "Rwanda",
		flag: "🇷🇼",
	},
	{
		name: "Saint Barthélemy",
		flag: "🇧🇱",
	},
	{
		name: "Saint Helena, Ascension and Tristan da Cunha",
		flag: "🇸🇭",
	},
	{
		name: "Saint Kitts and Nevis",
		flag: "🇰🇳",
	},
	{
		name: "Saint Lucia",
		flag: "🇱🇨",
	},
	{
		name: "Saint Martin (French part)",
		flag: "🇲🇫",
	},
	{
		name: "Saint Pierre and Miquelon",
		flag: "🇵🇲",
	},
	{
		name: "Saint Vincent and the Grenadines",
		flag: "🇻🇨",
	},
	{
		name: "Samoa",
		flag: "🇼🇸",
	},
	{
		name: "San Marino",
		flag: "🇸🇲",
	},
	{
		name: "Sao Tome and Principe",
		flag: "🇸🇹",
	},
	{
		name: "Saudi Arabia",
		flag: "🇸🇦",
	},
	{
		name: "Senegal",
		flag: "🇸🇳",
	},
	{
		name: "Serbia",
		flag: "🇷🇸",
	},
	{
		name: "Seychelles",
		flag: "🇸🇨",
	},
	{
		name: "Sierra Leone",
		flag: "🇸🇱",
	},
	{
		name: "Singapore",
		flag: "🇸🇬",
	},
	{
		name: "Sint Maarten (Dutch part)",
		flag: "🇸🇽",
	},
	{
		name: "Slovakia",
		flag: "🇸🇰",
	},
	{
		name: "Slovenia",
		flag: "🇸🇮",
	},
	{
		name: "Solomon Islands",
		flag: "🇸🇧",
	},
	{
		name: "Somalia",
		flag: "🇸🇴",
	},
	{
		name: "South Africa",
		flag: "🇿🇦",
	},
	{
		name: "South Georgia and the South Sandwich Islands",
		flag: "🇬🇸",
	},
	{
		name: "South Sudan",
		flag: "🇸🇸",
	},
	{
		name: "Spain",
		flag: "🇪🇸",
	},
	{
		name: "Sri Lanka",
		flag: "🇱🇰",
	},
	{
		name: "Sudan",
		flag: "🇸🇩",
	},
	{
		name: "Suriname",
		flag: "🇸🇷",
	},
	{
		name: "Svalbard and Jan Mayen",
		flag: "🇸🇯",
	},
	{
		name: "Swaziland",
		flag: "🇸🇿",
	},
	{
		name: "Sweden",
		flag: "🇸🇪",
	},
	{
		name: "Switzerland",
		flag: "🇨🇭",
	},
	{
		name: "Syrian Arab Republic",
		flag: "🇸🇾",
	},
	{
		name: "Taiwan, Province of China",
		flag: "🇹🇼",
	},
	{
		name: "Tajikistan",
		flag: "🇹🇯",
	},
	{
		name: "Tanzania, United Republic of",
		flag: "🇹🇿",
	},
	{
		name: "Thailand",
		flag: "🇹🇭",
	},
	{
		name: "Timor-Leste",
		flag: "🇹🇱",
	},
	{
		name: "Togo",
		flag: "🇹🇬",
	},
	{
		name: "Tokelau",
		flag: "🇹🇰",
	},
	{
		name: "Tonga",
		flag: "🇹🇴",
	},
	{
		name: "Trinidad and Tobago",
		flag: "🇹🇹",
	},
	{
		name: "Tunisia",
		flag: "🇹🇳",
	},
	{
		name: "Turkey",
		flag: "🇹🇷",
	},
	{
		name: "Turkmenistan",
		flag: "🇹🇲",
	},
	{
		name: "Turks and Caicos Islands",
		flag: "🇹🇨",
	},
	{
		name: "Tuvalu",
		flag: "🇹🇻",
	},
	{
		name: "Uganda",
		flag: "🇺🇬",
	},
	{
		name: "Ukraine",
		flag: "🇺🇦",
	},
	{
		name: "United Arab Emirates",
		flag: "🇦🇪",
	},
	{
		name: "United Kingdom",
		flag: "🇬🇧",
	},
	{
		name: "United States",
		flag: "🇺🇸",
	},
	{
		name: "United States Minor Outlying Islands",
		flag: "🇺🇲",
	},
	{
		name: "Uruguay",
		flag: "🇺🇾",
	},
	{
		name: "Uzbekistan",
		flag: "🇺🇿",
	},
	{
		name: "Vanuatu",
		flag: "🇻🇺",
	},
	{
		name: "Venezuela, Bolivarian Republic of",
		flag: "🇻🇪",
	},
	{
		name: "Vietnam",
		flag: "🇻🇳",
	},
	{
		name: "Virgin Islands, British",
		flag: "🇻🇬",
	},
	{
		name: "Virgin Islands, U.S.",
		flag: "🇻🇮",
	},
	{
		name: "Wallis and Futuna",
		flag: "🇼🇫",
	},
	{
		name: "Western Sahara",
		flag: "🇪🇭",
	},
	{
		name: "Yemen",
		flag: "🇾🇪",
	},
	{
		name: "Zambia",
		flag: "🇿🇲",
	},
	{
		name: "Zimbabwe",
		flag: "🇿🇼",
	},
];
